const ApproachSection = () => {
  const phases = [
    {
      number: '01',
      title: 'Assess',
      description:
        'Comprehensive evaluation of current operations, systems, workflows, and growth opportunities to identify optimization areas.',
      icon: 'ri-search-eye-line',
    },
    {
      number: '02',
      title: 'Design',
      description:
        'Strategic planning and solution architecture tailored to your practice needs, compliance requirements, and growth objectives.',
      icon: 'ri-draft-line',
    },
    {
      number: '03',
      title: 'Implement',
      description:
        'Structured deployment of systems, processes, and technologies with hands-on support and change management guidance.',
      icon: 'ri-tools-line',
    },
    {
      number: '04',
      title: 'Optimize & Scale',
      description:
        'Continuous improvement, performance monitoring, and scalable frameworks to ensure long-term operational excellence.',
      icon: 'ri-rocket-line',
    },
  ];

  return (
    <section id="approach" className="py-24 bg-gray-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-widest text-gold mb-4 font-semibold">
            OUR METHODOLOGY
          </p>
          <h2 className="font-serif text-5xl font-bold text-navy-primary mb-8">
            Four-Step Consulting Framework
          </h2>
          <p className="text-base text-charcoal max-w-3xl mx-auto leading-relaxed">
            We emphasize operational clarity, efficiency, compliance awareness,
            and long-term scalability through our proven consulting approach.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {phases.map((phase, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 relative cursor-pointer"
            >
              <div className="absolute top-8 left-8 text-8xl font-light text-gold/20">
                {phase.number}
              </div>

              <div className="relative z-10">
                <h3 className="text-3xl font-bold text-navy-primary mb-6 mt-8">
                  {phase.title}
                </h3>

                <p className="text-sm text-charcoal leading-relaxed mb-8">
                  {phase.description}
                </p>

                <div className="w-12 h-12 flex items-center justify-center">
                  <i
                    className={`${phase.icon} text-3xl text-gold`}
                  ></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <a
            href="/about"
            className="inline-block px-10 py-4 border-2 border-gold text-gold text-base font-semibold rounded-lg hover:bg-gold hover:text-navy-primary transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore Our Methodology
          </a>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;